import { am } from './utils';
import config from './../config';

import httpClient from '@/utils/httpClient';
import logger from '@/utils/logger';

export const CREATE_SAMPLE = am('CREATE_SAMPLE');

export const state = {
  isCreateSampleRequestPending: false,
  isCreateSampleRequestFailed: false
};

const getters = {};

export const actions = {
  async createSample({ commit }) {
    commit(CREATE_SAMPLE.STARTED);
    try {
      const topic = await httpClient.post(config.apihostname+'/projects/', {
        title: 'Sample Topic',
        description: 'Some funny question to get a taste of it'
      });

      const tasks = await httpClient.post(config.apihostname+`/projects/${topic.id}/tasks/batch`, ds);

      commit(CREATE_SAMPLE.COMPLETED);

      return [topic, tasks];
    } catch (e) {
      commit(CREATE_SAMPLE.FAILED);
      logger.error(e);
    }
  }
};

export const mutations = {
  [CREATE_SAMPLE.STARTED](state) {
    state.isCreateSampleRequestPending = true;
    state.isCreateSampleRequestFailed = false;
  },
  [CREATE_SAMPLE.FAILED](state) {
    state.isCreateSampleRequestPending = false;
    state.isCreateSampleRequestFailed = true;
  },
  [CREATE_SAMPLE.COMPLETED](state) {
    state.isCreateSampleRequestPending = false;
    state.isCreateSampleRequestFailed = true;
  }
};
const ds = [
  {
    question: 'Do you agree with the following statement?',
    text:
      "Good friends should lie to you to make you feel better about yourself rather than telling you the truth...because it's the right thing to do."
  },
  {
    question: 'Do you agree with the following statement?',
    text:
      "A friend should tell you to see a counsellor if you had a bad day and your friend doesn't feel like hearing about it."
  },
  {
    question: 'Do you agree with the following statement?',
    text: 'Good friends can disagree without hurting each other.'
  },
  {
    question: 'Do you agree with the following statement?',
    text: 'Friends should borrow each others clothes and misplace them and repeatedly lie about the situation.'
  },
  {
    question: 'Do you agree with the following statement?',
    text: "A friend should keep everything bottled up inside so that arguments don't arise."
  },
  { question: 'Do you agree with the following statement?', text: 'Friends should be selfish and not selfless.' },
  { question: 'Do you agree with the following statement?', text: 'Good friends give each other room to change.' },
  {
    question: 'Do you agree with the following statement?',
    text: "You should never be friends with someone who your other friends don't like."
  },
  {
    question: 'Do you agree with the following statement?',
    text: "You can only have a certain amount of friends or else you'll become to overwhelmed."
  },
  {
    question: 'Do you agree with the following statement?',
    text:
      "In order to communicate with your friends, you should establish that the only way you can all get along is if you're always considered right."
  },
  {
    question: 'Do you agree with the following statement?',
    text: 'Hanging out with your friends should be a memorable experience and should NOT feel like a task.'
  },
  {
    question: 'Do you agree with the following statement?',
    text: 'Friends should be willing to stick up for each other.'
  },
  { question: 'Do you agree with the following statement?', text: 'The color orange is named after the fruit.' },
  {
    question: 'Do you agree with the following statement?',
    text: 'You can legally dring alcohol while driving in Mississippi.'
  },
  { question: 'Do you agree with the following statement?', text: 'George Washington had wooden teeth.' },
  { question: 'Do you agree with the following statement?', text: 'It is illegal to pee in the ocean in Portugal.' },
  { question: 'Do you agree with the following statement?', text: 'Space between the eyebrows is called ""rasceta"".' },
  { question: 'Do you agree with the following statement?', text: 'You can lead a caw down stairs but now upstairs.' },
  { question: 'Do you agree with the following statement?', text: 'Some turtles can breathe through their butts.' },
  { question: 'Is the following statement true?', text: 'South Africa has 25 official languages.' },
  { question: 'Is the following statement true?', text: 'Mark Twain invented the elastic waistband.' },
  { question: 'Is the following statement true?', text: 'Google was originally called ""backrub"".' },
  { question: 'Is the following statement true?', text: 'There is a planet that rains glass sideways.' },
  { question: 'Do you think it is true?', text: 'McDonalds only serves McLobster in Cape Cod, Massachusetts.' },
  { question: 'Do you think it is true?', text: 'President Calvin Coolidge had a pet racoon.' },
  { question: 'Do you think it is true?', text: "Michael J. Fox's middle name is Garth." },
  { question: 'Do you think it is true?', text: 'You cannot die from drinking too much water.' },
  {
    question: 'Do you think it is true?',
    text: 'Albert Einstein was once offered the position of President of Israel.'
  },
  {
    question: 'Can you believe this?',
    text: 'Only 4 percent of Americans surveyed consider themselves less intelligent than average.'
  },
  {
    question: 'Do you think it is true?',
    text: 'You are more likely to be legally executed than killed by lightning.'
  },
  { question: 'Do you think it is true?', text: 'You only use 10 percent of your brain.' },
  { question: 'Do you think it is true?', text: 'More than half of all pilots admit to sleeping on the job.' },
  {
    question: 'Do you think it is true?',
    text: 'The average person spends five years waiting in line in their lifetime.'
  },
  { question: 'Do you think it is true?', text: 'Domestic violence increases by 40 percent on Super Bowl Sunday.' },
  {
    question: 'Can you believe this?',
    text: 'By age 3, rich kids have heard 30 million more words than very poor kids.'
  },
  {
    question: 'Can you believe this?',
    text: 'Only 5 percent of people wash their hands properly after using a public restroom.'
  },
  { question: 'Can you believe this?', text: 'One in every 200 men on Earth is descended from Genghis Khan.' },
  {
    question: 'Can you believe this?',
    text: 'Fifty percent of wealth on planet Earth is controlled by one percent of the population.'
  },
  { question: 'Can you believe this?', text: 'Eighty percent of Soviet males born in 1923 were killed in WWII.' },
  { question: 'Can you believe this?', text: 'Humans share 95 percent of their DNA with bananas.' },
  { question: 'Can you believe this?', text: 'The greater Tokyo area has a bigger population than Canada.' },
  { question: 'Can you believe this?', text: 'Most kidnapped kids are taken by strangers.' },
  { question: 'Can you believe this?', text: 'There are more trees on Earth than stars in the Milky Way galaxy.' },
  { question: 'Can you believe this?', text: 'One in five college students is the victim of rape.' },
  {
    question: 'Can you believe this?',
    text: 'Fifteen percent of all daily Google searches have never been searched before.'
  },
  { question: 'Can you believe this?', text: "There are more libraries in the U.S. than McDonald's." },
  { question: 'Can you believe this?', text: 'Only 3 out of 5 college students graduate within 6 years.' },
  { question: 'Can you believe this?', text: 'All red wine gets better with age.' },
  { question: 'Can you believe this?', text: 'Three out of four Canadians live within 100 miles of the U.S. border.' },
  { question: 'Can you believe this?', text: 'High school graduation rates hit an all-time low in 2016.' },
  { question: 'Can you believe this?', text: 'Violent crime hit an all-time high in 2016.' },
  { question: 'Can you believe this?', text: 'Humans and dinosaurs walked the Earth at the same time.' },
  { question: 'Can you believe this?', text: 'One in three people in the world has no access to a toilet.' },
  { question: 'Can you believe this?', text: 'One in four U.S. schools is defined as high-poverty.' },
  { question: 'Can you believe this?', text: 'Cleopatra lived during the construction of the Giza pyramids.' },
  { question: 'Can you believe this?', text: 'The global adult literacy rate is 84 percent.' },
  { question: 'Can you believe this?', text: 'Bangladesh has more people than Russia.' },
  {
    question: 'Can you believe this?',
    text: 'Thirty percent of traffic in downtown areas comes from people trying to park.'
  }
];

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
